import { supabase } from './supabase.js';
import { getValidAccessToken, readSession } from './session.js';

const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? '').replace(/\/+$/, '');
const PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '';

const SPEC = {
  video:  { rpc: 'guide_submit_video',  key: (uid: string, ext: string) => `${uid}/intro-video.${ext}` },
  resume: { rpc: 'guide_submit_resume', key: (uid: string, ext: string) => `${uid}/resume.${ext}` },
} as const;

/** Browser→Storage upload (RLS-scoped to the caller's uid) then a server-side
 *  stage advance via the guide_submit_* RPC. Throws on any failure. */
export async function uploadGuideDocument(kind: 'video' | 'resume', file: File): Promise<void> {
  const uid = readSession()?.user?.id;
  if (!uid) throw new Error('not signed in');
  const ext = (file.name.split('.').pop() ?? 'bin').toLowerCase();
  const path = SPEC[kind].key(uid, ext);

  const { error: upErr } = await supabase.storage.from('guide-documents')
    .upload(path, file, { upsert: true, contentType: file.type || 'application/octet-stream' });
  if (upErr) throw new Error(upErr.message);

  const accessToken = await getValidAccessToken();
  const res = await fetch(`${SUPABASE_URL}/rest/v1/rpc/${SPEC[kind].rpc}`, {
    method: 'POST',
    headers: { apikey: PUBLISHABLE_KEY, Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ p_path: path }),
  });
  if (!res.ok) throw new Error(`stage advance failed (HTTP ${res.status})`);
}
